import env from 'config';

export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  env: env.identifier,
  'ws-seed': Date.now().toString(),
};
